import React from 'react';

import './index.scss';

interface ParamsText {
  status: string | undefined;
  value: string | undefined;
}

const TextFieldGrid: React.FC<ParamsText> = ({status, value}) => {
  return (
    <span
        className={
          status === 'R'
            ? 'texto-campo-erro'
            : 'texto-campo-normal'
        }
      >
        {value}
      </span>
  )
}

export default TextFieldGrid;
